import classNames from 'classnames';
import { Box, Flex } from 'component/base/Grid';
import { Design } from 'enums/design';
import React from 'react';
import { FieldMetaState } from 'react-final-form';

import {
  Action,
  ErrorMessage,
  FieldContainer,
  IconContainer,
  Label,
  LabelText,
  OptionalText,
} from './styles';

interface IProps {
  children?: any;
  label?: string | JSX.Element;
  optional?: boolean;
  action?: JSX.Element | null;
  inlineLabel?: boolean;
  meta: FieldMetaState<any>;
  icon?: JSX.Element | null;
  iconDesign?: Design;
  // is a react-select field
  isSelect?: boolean;
  errorOnModify?: boolean;
}

const FormField = ({
  action,
  children,
  label,
  optional = false,
  meta,
  inlineLabel,
  icon,
  iconDesign,
  isSelect,
  errorOnModify,
}: IProps) => {
  let hasError =
    ((meta.touched || meta.initial !== undefined) && meta.error) ||
    (errorOnModify && meta.modified && meta.error);

  if (isSelect) {
    hasError = meta.touched && meta.error;
  }

  const classname = classNames({
    error: hasError,
  });

  const Container = label ? Label : React.Fragment;
  const containerProps = label ? { $inline: inlineLabel } : {};

  return (
    <div className={classname}>
      <Container {...containerProps}>
        <Flex>
          {label && <LabelText>{label}</LabelText>}
          {optional && <OptionalText>(Optional)</OptionalText>}
          {action && <Action py="8px">{action}</Action>}
        </Flex>
        <FieldContainer>
          {icon && <IconContainer design={iconDesign}>{icon}</IconContainer>}
          {children}
        </FieldContainer>
        {hasError && typeof meta.error === 'string' && (
          <Box className="errorMessage">
            <ErrorMessage>{meta.error}</ErrorMessage>
          </Box>
        )}
        {hasError && typeof meta.error !== 'string' && meta.error}
      </Container>
    </div>
  );
};

export default FormField;
